import { render } from "./HdBadge.vue?vue&type=template&id=00e49cb0"
import script from "./HdBadge.vue?vue&type=script&lang=js"
export * from "./HdBadge.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__